import { apiIsomorphicFetchUserEnvironment } from 'api/userEnvironment/apiFetchUserEnvironment';
import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { redirectRequireAuthentication } from 'modules/auth/routing/redirect-require-authentication';
import { userDashboardCreateEventRoute } from 'modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';

import { UserDashboardCreateEventPageLoadable } from './UserDashboardCreateEventPageLoadable';

export const handle = {
  variant: 'base',
  darkBackground: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof userDashboardCreateEventRoute>) {
  const [{ user }] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    UserDashboardCreateEventPageLoadable.load(),
  ]);

  if (!user) return redirectRequireAuthentication({ request });
}

export default function UserDashboardCreateEventHorizonRoute() {
  return <UserDashboardCreateEventPageLoadable />;
}
